import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    Tawk_API?: any;
    Tawk_LoadStart?: Date;
  }
}

const TawkToWidget = () => {
  const user = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log('TawkToWidget: Initializing...');
    
    // Initialize Tawk.to
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    // Configuration based on user authentication
    if (user) {
      // For authenticated users
      window.Tawk_API.onLoad = function() {
        console.log('Tawk.to loaded for authenticated user');
        
        // Set user attributes
        window.Tawk_API.setAttributes({
          'name': user.user_metadata?.name || user.email?.split('@')[0] || 'User',
          'email': user.email || '',
          'userId': user.id,
          'userType': user.user_metadata?.user_type || 'tenant'
        }, function(error: any) {
          if (error) {
            console.error('Error setting user attributes:', error);
          }
        });

        // Check if viewing a property
        const propertyMatch = location.pathname.match(/^\/property\/(.+)$/);
        if (propertyMatch) {
          const propertyId = propertyMatch[1];
          window.Tawk_API.setAttributes({
            'currentPropertyId': propertyId,
            'viewingProperty': 'true'
          });
        }
      };
    } else {
      // For visitors - configure pre-chat form
      window.Tawk_API.onLoad = function() {
        console.log('Tawk.to loaded for visitor');
      };

      // Handle pre-chat form submission
      window.Tawk_API.onPrechatSubmit = function(data: any) {
        console.log('Pre-chat form submitted:', data);
        
        // Basic validation
        if (!data.name || !data.email) {
          alert('Please provide both your name and email address to start the chat.');
          return false;
        }
        
        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(data.email)) {
          alert('Please provide a valid email address.');
          return false;
        }
        
        return true;
      };
    }

    // General event handlers
    window.Tawk_API.onChatStarted = function() {
      console.log('Chat started');
    };

    // Load Tawk.to script using the standard method
    console.log('TawkToWidget: Loading Tawk.to script...');
    (function(){
      var s1=document.createElement("script");
      var s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/574f23abc416f347285c6df8/default';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s1.onload = function() {
        console.log('TawkToWidget: Script loaded successfully');
      };
      s1.onerror = function() {
        console.error('TawkToWidget: Script failed to load');
      };
      s0.parentNode?.insertBefore(s1,s0);
    })();

    // Cleanup function
    return () => {
      try {
        const tawkScript = document.querySelector('script[src*="tawk.to"]');
        if (tawkScript) {
          tawkScript.remove();
        }
        
        // Remove Tawk.to widget from DOM
        const tawkWidget = document.getElementById('tawk-widget-container');
        if (tawkWidget) {
          tawkWidget.remove();
        }
        
        delete window.Tawk_API;
        delete window.Tawk_LoadStart;
      } catch (error) {
        console.error('Error cleaning up Tawk.to:', error);
      }
    };
  }, [user, location.pathname]);

  return null;
};

export default TawkToWidget;